import type { ParentComponent } from "../../lib/types";

const Number: ParentComponent = ({ children }) => (
	<ul className="list-decimal pl-6 font-serif text-sm leading-[1.6] text-foreground not-last:mb-[0.5lh] desktop:pl-8 desktop:text-md">
		{children}
	</ul>
);

export { Number };
